import {createTypes} from 'reduxsauce'

export const defaultSizes = createTypes(`
  X_SMALL
  SMALL
  DEFAULT
  MEDIUM
  LARGE
  X_LARGE
`)

export const createSizes = (x_small, small, def, medium, large, x_large) => {
  return {
    X_SMALL: x_small,
    SMALL: small,
    DEFAULT: def,
    MEDIUM: medium,
    LARGE: large,
    X_LARGE: x_large,
  }
}
